import './stylesheets/default/SubscriptionCard.css'
import './stylesheets/flat/SubscriptionCardFlat.css'
import './stylesheets/neumorphism/SubscriptionCardNeumorphism.css'
import './stylesheets/neobrutalism/SubscriptionCardNeobrutalism.css'
import './stylesheets/glassmorphism/SubscriptionCardGlassmorphism.css'


function SubscriptionCard({style}){
    return(
        <div className={`subscription-card-${style}`}>
            <h1 className={`subscription-title-${style}`}>Subscriptions</h1>
            <div className={`card-container-${style}`}>
                <div className={`card-${style}`}>
                    <h2 className={`card-title-${style}`}>Free Tier</h2>
                    <div className={`card-price-container-${style}`}>
                        <h3 className={`card-price-${style}`}>$0</h3>
                        <h3 className={`card-price-period-${style}`}>/mo</h3>
                    </div>
                    
                    <ul className={`card-ul-${style}`}>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>

                    </ul>
                    <button className={`subscription-button-${style}`}>Select</button>
                </div>
                <div className={`card-${style}`}>
                    <h2 className={`card-title-${style}`}>Standard Tier</h2>
                    <div className={`card-price-container-${style}`}>
                        <h3 className={`card-price-${style}`}>$7.99</h3>
                        <h3 className={`card-price-period-${style}`}>/mo</h3>
                    </div>
                    <ul className={`card-ul-${style}`}>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>

                    </ul>
                    <button className={`subscription-button-${style}`}>Select</button>
                </div>
                <div className={`card-${style}`}>
                    <h2 className={`card-title-${style}`}>Premium Tier</h2>
                    <div className={`card-price-container-${style}`}>
                        <h3 className={`card-price-${style}`}>$13.99</h3>
                        <h3 className={`card-price-period-${style}`}>/mo</h3>
                    </div>
                    <ul className={`card-ul-${style}`}>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>
                        <li className={`card-li-${style}`}> List Item </li>

                    </ul>
                    <button className={`subscription-button-${style}`}>Select</button>
                </div>

            </div>
        </div>
    )
}

export default SubscriptionCard